import { Document } from '@contentful/rich-text-types'
import { useState } from 'react'
import { RichText } from '~/components/RichText'
import { Question } from './config'

export const Faq = ({ question, answer }: Question) => {
  const [show, setShow] = useState(false)

  return (
    <>
      <div className="max-md:max-w-[315px] lg:w-[570px] max-lg:w-full max-lg:text-tablet-s border-b border-neutral-15 mt-4">
        <div className="flex justify-between items-center" onClick={() => setShow(!show)}>
          <p className="max-md:text-mobile-xs !leading-7 text-s text-neutral-100 w-full font-tt_talent pt-1 pr-8 pb-1 pl-0 font-normal">
            {question}
          </p>
          {show ? (
            <svg
              fill="#000000"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g data-name="Layer 2">
                <g data-name="arrow-ios-upward">
                  <rect width="24" height="24" transform="rotate(180 12 12)" opacity="0" />
                  <path d="M18 15a1 1 0 0 1-.64-.23L12 10.29l-5.37 4.32a1 1 0 0 1-1.41-.15 1 1 0 0 1 .15-1.41l6-4.83a1 1 0 0 1 1.27 0l6 5a1 1 0 0 1 .13 1.41A1 1 0 0 1 18 15z" />
                </g>
              </g>
            </svg>
          ) : (
            <svg
              fill="#000000"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g data-name="Layer 2">
                <g data-name="arrow-ios-downward">
                  <rect width="24" height="9" opacity="0" />
                  <path d="M12 16a1 1 0 0 1-.64-.23l-6-5a1 1 0 1 1 1.28-1.54L12 13.71l5.36-4.32a1 1 0 0 1 1.41.15 1 1 0 0 1-.14 1.46l-6 4.83A1 1 0 0 1 12 16z" />
                </g>
              </g>
            </svg>
          )}
        </div>

        <p className="overflow-hidden font-tt_talent font-normal text-s max-md:w-[288px] max-lg:w-[395px] mt-3 w-[648px] [&>article]:[&>p]:text-[22px]">
          {show && <RichText doc={answer as unknown as Document} />}
        </p>
      </div>
    </>
  )
}
